<div class="h-20 min-h-20 rounded overflow-hidden">
  <ion-card class="ion-no-margin rounded-none h-full"
            [routerLink]="'/articles/'+entry.category.slug+'/detail/'+entry.slug">
    <ion-card-content class="ion-no-padding h-full">

      <div class="flex bg-stone-100 dark:bg-stone-900 h-full">
        <div class="w-20 min-w-20">
          @if (entry.images && entry.images.length > 0) {
            <img src="{{ entry.images[0] }}" alt="{{ entry.title }}"
                 [routerLink]="'/articles/'+entry.category.slug+'/detail/'+entry.slug"
                 class="w-full h-20 rounded-l object-cover aspect-square"/>
          } @else {
            <div class="h-full flex items-center justify-center">
              <ion-icon name="image" class="text-5xl text-gray-500"/>
            </div>
          }
        </div>

        <div class="pl-3 flex flex-col justify-center">
          <div>
            <h3 class="uppercase !text-xs !m-0 !p-0">
              {{ entry.type_label }} &middot; {{ entry.category.title }}
              @if (entry.price) {
                &middot; {{ entry.price.formatted }}
                @if (entry.is_basis_for_negotiation) {
                  (VB)
                }
              } @else {
                &middot; Kostenlos
              }
            </h3>
          </div>
          <div class="">
            <h2 class="!text-xl !m-0 !p-0 text-gray-900 dark:text-gray-300">
              <a class="!text-inherit line-clamp-1 min-w-0"
                 [routerLink]="'/articles/'+entry.category.slug+'/detail/'+entry.slug">
                {{ entry.title }}
              </a>
            </h2>
          </div>

          <div class="flex items-center gap-x-3 overflow-hidden max-w-full min-w-0 plt-ios:text-sm">
            <div class="flex items-center">
              <ion-icon name="eye" class="text-gray-500 pr-1"/>
              {{ entry.views }}
            </div>

            <div class="flex items-center">
              <ion-icon name="calendar" class="text-gray-500 pr-1"/>
              {{ entry.created_at | date:'dd.MM.yyyy' }}
            </div>

            <div class="inline-flex items-center truncate min-w-0">
              <ion-icon name="person" class="text-gray-500 pr-1"/>
              {{ entry.owner.name }}
            </div>

          </div>
        </div>
      </div>
    </ion-card-content>
  </ion-card>
</div>
